import { beAccountSettimgsApiGetAccountLimits } from 'Api/beAccountSettingsApi'
import { beMessGetMessageDetails } from 'Api/BeMessApi'
import {
  beEmailCheckupGetEOAClients,
  beEmailCheckupGetMessagePreviews,
  beEmailCheckupRetryGetMessagePreview
} from 'Api/beEmailCheckupApi'
import { beSendGoCheckSendingProgress } from 'Api/beSendGoApi'

export async function getMessGetMessageDetails (idMessage) {
  const result = beMessGetMessageDetails(idMessage)
  return result
}

export async function getAccountLimits (idMessage) {
  const result = beAccountSettimgsApiGetAccountLimits(idMessage)
  return result
}

export async function getEOAClients () {
  const result = beEmailCheckupGetEOAClients()
  return result
}

export async function getEmailPreviews (idMessage, data) {
  const result = beEmailCheckupGetMessagePreviews(idMessage, data)
  return result
}

export async function retryGetEmailPreviews (idMessage) {
  const result = beEmailCheckupRetryGetMessagePreview(idMessage)
  return result
}

export async function isSendingMessage (idMessage) {
  const { Value } = await beSendGoCheckSendingProgress(idMessage)
  return Value
}
